import { TextInput } from '@mantine/core';
import { IFormInputSpecDeviceFieldAggregator } from 'pages/revisions-module/template-editor/editors/form/types';

/**
 * Preview for a device field aggregator input.
 */
export default function DeviceFieldAggregatorInputPreview({ spec }: { spec: IFormInputSpecDeviceFieldAggregator }) {
  return <TextInput required={spec.required} readOnly size="sm" />;
}
